import { Box, Radio } from '@mantine/core'

interface OptionCardProps {
  value: string
  label: string
  description?: string
  selected: boolean
  onSelect: (value: string) => void
}

const OptionCard = ({
  value,
  label,
  description,
  selected,
  onSelect,
}: OptionCardProps) => {
  return (
    <Box
      onClick={() => onSelect(value)}
      className={`shadow-xs cursor-pointer rounded-lg border px-4 py-3 hover:border-doubleNickel-brand-500 ${
        selected
          ? 'border-doubleNickel-brand-500 bg-doubleNickel-brand-25'
          : 'border-doubleNickel-gray-300'
      }`}
    >
      <Radio
        value={value}
        label={label}
        description={description}
        classNames={{
          label: 'text-sm font-medium text-doubleNickel-gray-900',
          description: 'text-xs leading-5 text-doubleNickel-gray-500',
        }}
      />
    </Box>
  )
}

export default OptionCard
